import axios from 'axios';
import Auth from '../auth';
import { getObleaResponseFailure, createObleaValidationRejection } from '../utilities';
import { normalizeBuscarNovedadesParams } from '../utilities/Novedades/normalizeBuscarNovedadesParams';
import {
    extractNovedadesResultadosRawList,
    normalizeNovedadItem
} from '../utilities/Novedades/extractNovedadesResultadosRawList';

export const url = "";

axios.interceptors.response.use(
    response => response,
    error => {
        const status = error?.response?.status;
        const url = error?.config?.url || '';

        const esIntegracionOAuth =
            url.includes('/oauth/zipnova') ||
            url.includes('/api/oauth/');

        const esProxyBff =
            url.includes('/Proxy') ||
            url.includes('/EncabezadoProxy') ||
            url.includes('/EncabezadosProxy');

        const isLocalhostRuntime =
            typeof window !== 'undefined' &&
            window.location &&
            window.location.hostname === 'localhost';

        if (status === 401 && !esIntegracionOAuth && !esProxyBff && !isLocalhostRuntime) {
            Auth.logout();
            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export const loginApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/account/login`,
            data: request
        }).then(response => {
            const AUTH_TOKEN = 'Bearer ' + response.data.token;
            window.localStorage.setItem("token", AUTH_TOKEN);
            axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const impersonateUserApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/account/impersonate`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getGrupoPlanesById = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/GrupoPlanes/Planes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getGrupoById = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/BuscarGrupoPlanes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const deleteGrupoPlanesById = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Administracion/GrupoPlanes?id=${id}`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getGrupoPlanesApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/BuscarGrupoPlanes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response ?? {});
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getPlanesPorParametrosApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/Administracion/BuscarPlanes`,
            params: params ?? null
        }
        ).then(response => {
          resolve(response ?? {});
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/GrupoPlanes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/ActualizarGrupoPlanes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const obtenerUsuariosDeSeller = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/BuscarProxy`,
            params: params ?? null
        }
        ).then(response => {
          resolve(response?.data ?? {});
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postSearchUsuarioApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/ObtenerUsuarioProxy`,
            params: data
        })
            .then(response => {
                resolve(response?.data ?? {});
            })
            .catch(err => reject(err));
    });
};

export const postSearchTokenUsuario = (data) => {
    const rawId = data?.idUsuario ?? data?.IdUsuario;
    const idUsuario = Number(rawId);

    if (!Number.isFinite(idUsuario) || idUsuario <= 0) {
        return Promise.reject(new Error('idUsuario invalido para /api/Usuarios/ObtenerToken'));
    }

  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `${url}/api/Usuarios/ObtenerToken`,
      data: {
                idUsuario
      },
      headers: { 'Content-Type': 'application/json' }
    }
    ).then(response => {
      resolve(response);
    }
    ).catch(err => {
      reject(err);
    })
  })
}

export const obtenerTiposUsuarioApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/TipoUsuario`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postChangeStateUsuario = (data) => { // ESTE MÉTODO NO SE ESTÁ LLAMANDO DESDE NINGÚN LADO
    console.log(data, "🎀")
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/CambiarEstado`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const modificarUsuario = (data) => { // ESTE MÉTODO NO SE ESTÁ LLAMANDO DESDE NINGÚN LADO
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Usuarios`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postTiposPublicacionAsociarGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/AsociarGrupoPlanATipoPublicacion`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }

        ).catch(err => {
            reject(err);
        })
    })
}

export const postTiposPublicacionAsociarSeller = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/AsociarTipoPublicacionSeller`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getTiposPublicacion = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/TiposPublicacion`,
            params: request
        }).then(response => {
          resolve(response ?? {});
        }).catch(err => {
            reject(err);
        })
    })
}

export const getAuditoriaAdministracionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/ObtenerAuditoriaAdministracion`,
            params: request
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(err => {
            reject(err);
        })
    })
}

export const postAdministracionTiposPublicacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/TiposPublicacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putAdministracionTiposPublicacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/ActualizarTipoPublicacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const deleteAdministracionTiposPublicacion = (idTipoPublicacion, idUsuario) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Administracion/TiposPublicacion`,
            params: { IdTipoPublicacion: idTipoPublicacion, IdUsuario: idUsuario },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postFacturaOrdenes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}


export const postCrearOrden = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/CrearOrden`,
            data: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getFacturaOrdenesApi = (query) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${url}/api/Ordenes/Comprobantes?${query}`,
    }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
  })
}

export const getComprobanteOrdenes = (idOrden, idEstado) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/ObtenerComprobante?idOrden=${idOrden}&idEstado=${idEstado}`,
        }
        ).then(response => {
            const data = typeof response.data === "string" ? { oblea: response.data } : response.data;
            const failure = getObleaResponseFailure(data);
            if (failure.failed) {
                reject(createObleaValidationRejection(failure));
                return;
            }
            resolve(data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchSellersApi = (params) => { // ESTE MÉTODO NO SE ESTÁ UTILIZANDO EN NINGÚN COMPONENTE
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchDesplegableProveedoresApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/DesplegableProveedores`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchPublicacionesApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Proxy`,
            params: {
                ...params,
                DireccionOrdenamiento: 1,
                EntidadOrdenamiento: "idPublicacion"
            }
        }).then(response => {
            resolve(response?.data);
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchPublicacionesEncabezadoApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/EncabezadosProxy`,
            params: params
        }).then(response => {
            resolve(response?.data);
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchTipoPublicacionApi = (idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Tipos`,
            params: { idSeller: idSeller }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchPublicacionApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Proxy`,
            params: {
                idPublicacion: id,
                direccionOrdenamiento: 1,
                entidadOrdenamiento: "idPublicacion"
            }
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchPublicacionAuditoriaPrecioStockApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/AuditoriaPrecioStock`,
            params: params ?? null
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchSellerAuditoriaApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerAuditoriaSeller`,
            params: params ?? null
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchAuditoriaCompletaSellersApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerAuditoriaCompletaSellers`,
            params: params ?? null
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchPublicacionPorSkuMarketApi = (skuMarket) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Proxy`,
            params: {
                skuMarket: skuMarket,
                direccionOrdenamiento: 1,
                entidadOrdenamiento: "idPublicacion"
            }
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchVariacionesApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/Tipos/GetTiposEstadosVariaciones`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchMarcasApi = (descripcion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Articulos/ObtenerMarcas`,
            params: {
                descripcion: descripcion
            }
        }).then(response => {
            const data = response?.data ?? {};
            const marcasArray = Array.isArray(data?.marcas)
                ? data.marcas
                : Array.isArray(data?.Marcas)
                    ? data.Marcas
                    : Array.isArray(data)
                        ? data
                        : [];
            resolve({
                ...data,
                elementos: marcasArray
            });
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchMarcaApi = (idMarca) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Articulos/ObtenerMarcas`,
            params: {
                descripcion: idMarca
            }
        }).then(response => {
            const data = response?.data ?? {};
            const marcasArray = Array.isArray(data?.marcas)
                ? data.marcas
                : Array.isArray(data?.Marcas)
                    ? data.Marcas
                    : Array.isArray(data)
                        ? data
                        : [];
            resolve({
                ...data,
                elementos: marcasArray
            });
        }).catch((error) => {
            reject(error);
        })
    })
}


export const fetchCategoriasApi = (descripcion) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
            url: `${url}/api/Articulos/ObtenerCategorias`,
      params: {
                descripcion: descripcion
      }
    }).then(response => {
      const data = response?.data ?? {};
            const categoriasArray = Array.isArray(data?.categorias)
                ? data.categorias
                : Array.isArray(data?.Categorias)
                    ? data.Categorias
                    : Array.isArray(data)
                        ? data
                        : [];
      resolve({
        ...data,
        elementos: categoriasArray
      });
    }).catch(error => {
      reject(error)
    })
  })
}

export const fetchCategoriaApi = (descripcion) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
            url: `${url}/api/Articulos/ObtenerCategorias`,
      params: {
        descripcion: descripcion,
      },
    }).then(response => {
      const data = response?.data ?? {};
            const categoriasArray = Array.isArray(data?.categorias)
                ? data.categorias
                : Array.isArray(data?.Categorias)
                    ? data.Categorias
                    : Array.isArray(data)
                        ? data
                        : [];
      resolve({
        ...data,
        elementos: categoriasArray
      });
    }).catch((error) => {
      reject(error);
    })
  })
}

export const createPublicacionApi = (publicacion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones`,
            data: publicacion
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updatePublicacionApi = (publicacion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones`,
            data: publicacion
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updateImagenesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ModificarImagenesBulk`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updatePosicionesImagenesApi = (request) => { // SE USA EN DrawAndDropImages pero el componente no se está usando.
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizarPosicionImagenes`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const deletePublicacionApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Publicaciones/${encodeURIComponent(id)}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchMotivosRevisionApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/Ordenes/ObtenerListaMotivosAnulacion`
        }).then((response) => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchMotivosSolicitudAnulacionApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/ObtenerListaMotivosAnulacion`
        }).then((response) => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error);
        })
    })
}

export const updatePublicacionEstadoVariacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/Variaciones`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postAprobarPublicacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/Aprobar`,
            data: request
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postDesaprobarPublicacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/Desaprobar`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const deleteSellerApi = (idSeller, idUsuario) => {
    return new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        params.set('IdSeller', idSeller ?? '');
        if (idUsuario != null && idUsuario !== '') {
            params.set('IdUsuario', idUsuario);
        }

        axios({
            method: 'post',
            url: `${url}/api/Sellers/EliminarSeller?${params.toString()}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const getOrden = (idOrden, idUsuario) => {

    let request = {
        IdOrden: idOrden,
        IdUsuario: idUsuario
    }

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/Proxy`,
            params: request
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(err => {
            reject(err);
        })
    })
};

export const fetchOrdenesParams = (request) => { // SE USA EN EL ACTIONS PERO EL MÉTODO DEL ACTIONS NO SE ESTÁ USANDO EN UN COMPONENTE
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/Proxy`,
            params: request
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenesEncabezadoParams = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/EncabezadoProxy`,
            params: params
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenesEnVerdeParams = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/OrdenesProveedores`,
            params: request
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/ObtenerEstadoVenta`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postAnularOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AnularEstadoVenta`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        })
    })
}

export const postAprobarOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AprobarEstadoVenta`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postSolicitudAnulacionOrdenApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/SolicitudAnulacion`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postAnulacionReversionOrdenApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AnulacionReversion`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const listSellers = () => { // ESTE MÉTODO NO SE ESTÁ USANDO EN NINGÚN COMPONENTE
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const listSellersParameters = (Descripcion, CantidadPagina, NumeroPagina) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar?Descripcion=${Descripcion || ''}&PageSize=${CantidadPagina}&Page=${NumeroPagina}`
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getSeller = (IdSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar?IdSeller=${IdSeller}&NumeroPagina=1&CantidadPagina=1`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getIntegradores = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Integrators`,
        }).then(response => {
            resolve(response.data.integradores);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getTipoFacturacion = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/Tipos/GetTiposFacturacion`,
        }).then(response => {
            resolve(response.data.tiposFacturacion);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getEstadosSeller = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Estados/Seller`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postSellerApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller`,
            data: data
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postUser = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/CrearUsuarioDesdeUnUsuario`,
            data
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}


export const editUser = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/${data.idUsuario}`,
            data
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const putSellerApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Sellers/EditarSeller`,
            data: data
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

const isFetchableImageUrl = (value) => /^https?:\/\//i.test(String(value ?? "").trim());

const postImageFile = (endpoint, img) => {
    if (!img?.type?.includes("image")) {
        return Promise.reject(new Error("Archivo incorrecto"));
    }

    const form = new FormData();
    form.append("file", img, img.name);

    return axios({
        url: endpoint,
        method: "POST",
        timeout: 0,
        data: form
    }).then((res) => {
        const imageUrl = res?.data?.url;
        if (!isFetchableImageUrl(imageUrl)) {
            return Promise.reject(new Error("La imagen no quedó accesible por URL"));
        }
        return res.data;
    });
};

export const createImageUrl = (img) => postImageFile("/Imagen", img);

export const createImageSellerUrl = (img) => postImageFile("/Imagen/Seller", img);

export const leerExcelPublicaciones = (formularioCompleto) => {
    return new Promise(resolve => {
        axios({
            "dataType": "html",
            "url": "/PublicacionesExcel",
            "method": "POST",
            "timeout": 0,
            "processData": false,
            "contentType": false,
            "data": formularioCompleto
        }).then(res => {
            resolve(res);
        })
    });
}

export const leerExcelPublicacionesPorCodigo = (formularioCompleto) => {
    return new Promise(resolve => {
        axios({
            "dataType": "html",
            "url": "/PublicacionesExcelPorCodigo",
            "method": "POST",
            "timeout": 0,
            "processData": false,
            "contentType": false,
            "data": formularioCompleto
        }).then(res => {
            resolve(res);
        })
    });
}

export const postCreacionMasivaPublicacionesApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/CreacionMasiva`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postExcelPublicaciones = (data) => {

    let listaAtributos = {
        "listaAtributos": data
    };

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasiva`,
            data: listaAtributos
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postExcelPublicacionesModerador = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasivaPorCodigo`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

/**
 * Actualización masiva bulk parcial → PUT api/Publicaciones/ActualizacionMasivaBulkParcial
 * No valida ni exige campos obligatorios del alta; el body puede incluir 1 o varios campos por publicación.
 */
export const putActualizacionMasivaBulkParcialApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasivaBulkParcial`,
            data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putExcelLiquidacionesFeeLogisticoApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ActualizacionMasivaFeeLogistico`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getFeeLogisticoSellersApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/FeeLogistico`
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getDatosFeeLogisticoSellersApi = (VigenciaFeeLogistico) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/DatosFeeLogisticoSellers`,
            params: { VigenciaFeeLogistico }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
}


export const fetchRebatesDeLiquidacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/Rebates`,
            params: request
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getLocalidades = (params) => {
    let params_1 = { ...params, NumeroPagina: 1, CantidadPagina: 500 };
    return new Promise((resolve) => {
        axios({
            method: 'get',
            url: `${url}/api/Localidades`,
            params: (params_1) ? params_1 : null
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            resolve(error);
        })
    })
}

export const getSituacionIva = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/SituacionIva`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getTiposAdquirientes = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Adquirientes`
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getTiposSexo = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Sexo`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionesListaSellers = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/Sellers/TraerSellersLiquidaciones`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getTiposConceptosApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/NovedadesLiquidaciones/BuscarTiposNovedad`
        }).then(response => {
          resolve(response?.data ?? {});
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionporid = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ConsultarDetalleLiquidacion`,
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getOrdenesParaNuevaLiquidacion = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarOrdenesPorFecha`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const postResumenOrdenesSellerParaLiquidar = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/ResumenOrdenesSellerParaLiquidar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
}

export const postAgregarOrdenesALiquidacion = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/AgregarOrdenesALiquidacion`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
}

export const getNovedadesParaNuevaLiquidacion = (request) => {
    const params = normalizeBuscarNovedadesParams(request);

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/NovedadesLiquidaciones/BuscarNovedadesLiquidaciones`,
            params
        }).then(response => {
            const data = response?.data ?? {};
            const rawList = extractNovedadesResultadosRawList(data);
            const novedades = rawList.map(normalizeNovedadItem);
            resolve({
                ...data,
                novedades
            });
        }).catch(error => {
            reject(error);
        })
    })
}

export const getLiquidacionPorIdOrdenes = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarOrdenesDeLiquidacion`,
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLogistica = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/Cotizaciones`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionPorIdNovedades = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/NovedadesLiquidaciones/BuscarNovedadesDeLiquidacion`,
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const postNovedad = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/NovedadesLiquidaciones/CrearNovedadParaLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postNuevaLiquidacionFinal = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CrearLiquidacionFinal`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postPrevisionLiquidacionesApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/PrevisionLiquidaciones`,
            data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
}

export const postNuevaLiquidacionFinalLogistica = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/EnvioPack/Cotizaciones`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postNuevaNovedadConcepto = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/NovedadesLiquidaciones/CrearConceptoNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getAccionesLiquidaciones = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
            url: `${url}/api/NovedadesLiquidaciones/TraerSubtipoNovedades`
    }).then(response => {
      const data = response?.data ?? {};
      const listadoNovedadesSubtipo = data?.listadoNovedadesSubtipo ?? data?.ListadoNovedadesSubtipo ?? data?.subTiposNovedades ?? data?.SubTiposNovedades ?? data?.elementos ?? data?.Elementos ?? data?.content ?? data?.Content ?? data?.data ?? [];
      resolve({
        ...data,
        listadoNovedadesSubtipo
      })
    }).catch(error => {
      reject(error)
    })
  })
}

export const getEstadosLiquidaciones = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${url}/api/NovedadesLiquidaciones/BuscarEstadosNovedades`
    }).then(response => {
      const data = response?.data ?? {};
      const listadoEstadosNovedades = data?.listadoEstadosNovedades ?? data?.ListadoEstadosNovedades ?? data?.estados ?? data?.Estados ?? [];
      resolve({
        ...data,
        listadoEstadosNovedades
      });
    }).catch(error => {
      reject(error)
    })
  })
}

export const getEstadosLiquidacionesCorrecto = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/EstadosLiquidaciones/ObtenerEstadosLiquidaciones`
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error)
        })
    })
}

export const getResultadosLiquidaciones = (request) => {
    const params = normalizeBuscarNovedadesParams(request);

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/NovedadesLiquidaciones/BuscarNovedadesLiquidaciones`,
            params
        }).then(response => {
            const data = response?.data ?? {};
            const rawList = extractNovedadesResultadosRawList(data);
            const novedades = rawList.map(normalizeNovedadItem);
            resolve({
                ...data,
                novedades
            });
        }).catch(err => {
            reject(err);
        })
    })
}

export const getLiquidacionesBusqueda = (params) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${url}/api/Liquidaciones/LiquidacionesBusqueda`,
      params
    }).then(response => {
      resolve(response.data);
    }).catch(err => {
      reject(err);
    })
  })
}

export const putEliminaNovedadFinal = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/NovedadesLiquidaciones/AnularNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEliminaConceptoFinal = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/NovedadesLiquidaciones/AnularTiposNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEliminaLiquidacionFinal = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/EliminarLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);

        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEditaConceptoFinal = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/NovedadesLiquidaciones/ActualizarConceptoNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEditaLiquidacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/EditarLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putConfirmarLiquidacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ConfirmarLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}


export const putEditaNovedadImporte = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/NovedadesLiquidaciones/EditarNovedad`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postFacturarLiquidacionApi = ({ idLiqui, IdLiqui, idLiquidacion, IdLiquidacion } = {}) => {
    const id = IdLiqui ?? idLiqui ?? IdLiquidacion ?? idLiquidacion;
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidacion/FacturarLiquidacion`,
            params: { IdLiqui: id }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
};

export const postGenerarNotaDeCreditoApi = ({ idLiqui }) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidacion/GenerarNotaCredito`,
            params: { idLiqui }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
};

export const putConfirmaNovedad = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/NovedadesLiquidaciones/ConfirmarNovedad`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const fetchExportarPublicacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/ExcelPublicaciones`,
            params: {
                FechaPubDesde: request?.fechaPubDesde ?? request?.FechaPubDesde ?? null,
                FechaPubHasta: request?.fechaPubHasta ?? request?.FechaPubHasta ?? null,
                IdSeller: request?.idSeller ?? request?.IdSeller ?? null,
                Categoria: request?.categoria ?? request?.Categoria ?? null,
                Marca: request?.marca ?? request?.Marca ?? null,
                Estado: request?.estado ?? request?.Estado ?? null,
                SkuSeller: request?.skuSeller ?? request?.SkuSeller ?? null,
                SkuMarket: request?.skuMarket ?? request?.SkuMarket ?? null,
                IdTipoPubli: request?.idTipoPubli ?? request?.IdTipoPubli ?? null,
                SinStock: request?.sinStock ?? request?.SinStock ?? null,
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const fetchExportarOrdenesApi = (request) => {
    return new Promise((resolve, reject) => {
        // POST: el BFF reenvía el body como query a la API externa. GET con `data` no envía filtros.
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/ExportarOrdenes`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarOrdenesTelefonicasApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/ExportarOrdenesTelefonicas`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarLiquidacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/Liquidaciones`,
            params: {
                idLiquidacion: request?.idLiquidacion ?? request?.IdLiquidacion ?? request?.id ?? request?.Id ?? null
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarSellersApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Sellers/ExportableSellers`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarMarcasApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/ExcelMarcas`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarCategoriasApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/ExcelSubfamilias`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const requestTokenResetPassword = (Email) => { // SE USA EN ACTIONS Y TAMBIÉN DIRECTAMENTE
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/TokenResetPassword?Email=${Email}`
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

// Admin helper: requests reset-password token but DOES NOT mutate auth/session.
export const requestTokenResetPasswordAdmin = (Email) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/Usuarios/TokenResetPassword?Email=${Email}`
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchTotalNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Landing/Notificaciones/Total`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchDetalleNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Notificaciones/Detalle`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchMarcarLeidasNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Notificaciones/MarcarLeidas`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchAjusteNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Notificaciones/Ajustes`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateAjusteNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Notificaciones/Ajustes`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        const endpoints = [
            `${url}/api/Rebates/VerRebate`,
            `${url}/api/Rebates/Buscar`
        ];

        const tryNext = (index, lastError) => {
            if (index >= endpoints.length) {
                reject(lastError);
                return;
            }

            axios({
                method: 'get',
                url: endpoints[index],
                params: { IdPublicacion: request }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.response?.status === 404 && index < endpoints.length - 1) {
                    tryNext(index + 1, error);
                    return;
                }

                reject(error)
            })
        };

        tryNext(0, null);
    });
}

export const fetchListRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Rebates/ListarRebates`,
            params: request
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarLiquidacionExcelApi = (idLiquidacion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/GenerarExcel/${idLiquidacion}`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        const endpoints = [
            `${url}/api/Rebates/NuevoRebate`,
            `${url}/api/Rebates/Nuevo`
        ];

        const tryNext = (index, lastError) => {
            if (index >= endpoints.length) {
                reject(lastError);
                return;
            }

            axios({
                method: 'post',
                url: endpoints[index],
                data: request
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.response?.status === 404 && index < endpoints.length - 1) {
                    tryNext(index + 1, error);
                    return;
                }

                reject(error);
            });
        };

        tryNext(0, null);
    });
}

export const updateRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        const endpoints = [
            `${url}/api/Rebates/ModificarRebate`,
            `${url}/api/Rebates/Modificar`
        ];

        const tryNext = (index, lastError) => {
            if (index >= endpoints.length) {
                reject(lastError);
                return;
            }

            axios({
                method: 'put',
                url: endpoints[index],
                data: request
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.response?.status === 404 && index < endpoints.length - 1) {
                    tryNext(index + 1, error);
                    return;
                }

                reject(error)
            })
        };

        tryNext(0, null);
    });
}

export const deleteRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        const endpoints = [
            `${url}/api/Rebates/EliminarRebate?IdRebate=${request}`,
            `${url}/api/Rebates?id=${request}`
        ];

        const tryNext = (index, lastError) => {
            if (index >= endpoints.length) {
                reject(lastError);
                return;
            }

            axios({
                method: 'delete',
                url: endpoints[index],
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.response?.status === 404 && index < endpoints.length - 1) {
                    tryNext(index + 1, error);
                    return;
                }

                reject(error)
            })
        };

        tryNext(0, null);
    });
}

export const postAprobarRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        const endpoints = [
            `${url}/api/Rebates/AprobarRebate`,
            `${url}/api/Rebates/Aprobar`
        ];

        const tryNext = (index, lastError) => {
            if (index >= endpoints.length) {
                reject(lastError);
                return;
            }

            axios({
                method: 'post',
                url: endpoints[index],
                data: request
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error?.response?.status === 404 && index < endpoints.length - 1) {
                    tryNext(index + 1, error);
                    return;
                }

                reject(error)
            })
        };

        tryNext(0, null);
    });
}

export const fetchComprobanteVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/ObleaVentaVerde`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const guardarDescargaObleaVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/ObleaVentaVerde`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchLogisticaPropiaApi = (idSeller) => {
    return axios.get(`${url}/api/LogisticaPropia/ConEscalas`, {
    params: { idSeller: Number(idSeller) }
  })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      throw error;
    });
};
export const estructuraFeeLogistico = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/EstructuraTablaCostoFee`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const updateFeeLogistico = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CrearFeeLogisticoSellerMegatone`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateLogisticaPropiaApi = (request) => {
  return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/LogisticaPropia`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            const status = error?.response?.status;
            if (status === 404 || status === 405) {
                axios({
                    method: 'put',
                    url: `${url}/api/LogisticaPropia/ModificarLogisticaPropiaSeller`,
                    data: request
                }).then(response => {
                    resolve(response.data);
                }).catch(legacyError => {
                    reject(legacyError);
                });
                return;
            }

            reject(error)
        })
  });
}

export const updateFeeLogisticoSellersApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ActualizacionFeeLogisticoSellers`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const updateFeeLogisticosActivoProximo = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/ActualizacionFeeLogisticoSellerMegatone`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const descargarObleaVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/DescargarObleaVentaVerde`,
            params: request
        }).then(response => {
            const failure = getObleaResponseFailure(response.data);
            if (failure.failed) {
                reject(createObleaValidationRejection(failure));
                return;
            }
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchGarantiasApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/GarantiaExtendida/ObtenerValoresGarantiaExtendida`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateUrlTrackingApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/ActualizarUrlTracking`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const putEstadoSellerApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/CambiarEstadoSeller`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const updatePublicacionPrecioYStockBulkApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasivaPrecioYStockBulk`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const updatePublicacionDimensionesBulkApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizarDimensionesBulk`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const updatePublicacionEstadoBulkApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/CambiarEstadoPublicacionBulk`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}
export const getLiquidacionPdf = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/LiquidacionPdf`,
            params: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

/** Detalle de liquidacion por idLiquidacion (base64 PDF). Ruta nueva: /api/Exportables/GenerarPdf/{idLiquidacion}. */
export const getExportablesGenerarPdfLiquidacionApi = (idLiquidacion) => {
    return axios({
        method: 'get',
        url: `${url}/api/Exportables/GenerarPdf/${idLiquidacion}`
    })
}

/** Factura de liquidacion por idLiquidacion — JSON { errores, archivo } (archivo = base64 PDF). Ruta nueva: /api/Exportables/ObtenerFacturaLiquidacion/{idLiquidacion}. */
export const getExportablesFacturaLiquidacionApi = (idLiquidacion) => {
    return axios({
        method: 'get',
        url: `${url}/api/Exportables/ObtenerFacturaLiquidacion/${idLiquidacion}`
    })
}

/** Subida de PDF de comprobantes (admin/category). Body JSON { archivo: base64 } → api/Liquidacion/ComprobantesPago/Procesar. */
export const postComprobantesLiquidacionPdfApi = (payload) => {
    return axios({
        method: 'post',
        url: `${url}/api/Liquidaciones/ComprobantesPdf`,
        data: payload,
        headers: { 'Content-Type': 'application/json' }
    })
}

/** Comprobante de pago por idSeller — JSON { errores, archivo } (archivo = base64 PDF). Ruta nueva: /api/Exportables/ObtenerComprobanteDePago/{idSeller}. */
export const getExportablesComprobanteDePagoApi = (idSeller) => {
    return axios({
        method: 'get',
        url: `${url}/api/Exportables/ObtenerComprobanteDePago/${idSeller}`
    })
}

export const fetchExportarCertificadosPdfApi = (idLiquidacion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/Certificados/${idLiquidacion}`,
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchExportarCertificadoImpuestosAnexoApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ExportarCertificadoImpuestosAnexos`,
            params: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchExportarRetencionesYPercepcionesApi = (idLiquidacion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/RetencionesYPercepciones/${idLiquidacion}`,
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postCalcularPercepcionRetencionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CalcularPercepcionRetencionesLiquidacion`,
            data: request,
            timeout: 0,
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getTipoComprobantesApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/CargasTributarias/TiposComprobantes`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getLiquidacionesAuditoriaApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/Transacciones/ListarTransacciones`,
            params,
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchAlicuotaIvaApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/AlicuotasIva`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postCrearCdnSellerApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/CrearCdnSeller`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const deleteCdnSellerApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/EliminarCdnSeller`,
            params: {
                IdBannerSeller: id,
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const updateCdnSellerApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/EditarCdnSeller`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getDetallesRetenciones = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/CargasTributarias/DetalleCargasTributarias`,
            params: {
                idLiquidacion: id
            }
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getProvinciaLocalidadByCodigoPostalApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerLocalidadProvincia`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const enlazarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/EnlazarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const confirmarMfaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/ConfirmarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const desenlazarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/DesenlazarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const deshabilitarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/DesenlazarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const postVerificarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/VerificarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const postCargarDatosBancariosApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/CargarDatosBancarios`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getDatosBancariosApi = (request) => {
    const idSeller = request?.IdSeller ?? request?.idSeller;
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerDatosBancariosSeller`,
            params: (idSeller !== undefined && idSeller !== null)
                ? { IdSeller: idSeller }
                : request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postMasivaImagenesExcelApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/CargaMasivaImagenesExcel`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const getFormatoExcel = ({ tipoExcel }) => {
    return new Promise((resolve, reject) => {
        const endpoints = [
            `${url}/api/Exportables/ExcelModelo`,
            `${url}/api/Exportables/Publicaciones/ModelosExcel`
        ];

        const tryNext = (index, lastError) => {
            if (index >= endpoints.length) {
                reject(lastError);
                return;
            }

            axios.get(endpoints[index], {
                params: { TipoModeloExcel: tipoExcel }
            })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    tryNext(index + 1, err);
                });
        };

        tryNext(0, null);
    });
};

export const getTotalizadores = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/Dashboard/informetarjetasdashboard`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const getEstadoResumen = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/Dashboard/resumenestadodeordenes`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const getTopProducto = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
          url: `${url}/api/Dashboard/topproductosporseller`,
            params: params ?? null
        })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export const getTopCategorias = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopCategorias`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getTopTipoPublicaciones = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopTipoPublicaciones`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getVentasMensuales = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/VentasMensuales`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const postChatBot = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/ChatBot`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postTicket = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ticket/Soporte`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchAgentsApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/Categorys`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}


export const postIniciarChat = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatIniciar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postFinalizarChat = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatFinalizar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}


export const postCrearChatInterno = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatCrear`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postChatMensaje = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatMensaje`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updateEstadoTiposPublicaciones = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/CambiarEstadoTipoPublicacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchGlobal = (searchValue, idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/BusquedaGlobal`,
            params: {
                entrada: searchValue,
                idSeller: idSeller
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}


export const getChatInterno = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/Categorys`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}
// export const getChatToken = (userId = null) => {

//         const params = userId ? `?userId=${userId}` : '';
//         axios({
//             method: 'get',
//             url: `${url}/api/Administracion/GetChatToken${params}`,
//             // No incluir headers de autorización porque es para obtener el token inicial
//         }).then(response => {
//             resolve(response.data);
//         }).catch(error => {
//             reject(error);
//         })
//     })
// }

export const fetchBancosApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerBancos`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postCargarDatosBancariosManualApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/CargarDatosBancariosManual`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getlistGestionDatosBancariosSellersTesoreriaApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/GestionDatosBancariosSellersTesoreria`,
            params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const updateEstadoBancarioCbuSellerApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Seller/CambiarEstadoDatoBancario`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// export const getChatToken = (userId = null) => {

//     const params = userId ? `?userId=${userId}` : '';
//     axios({
//       method: 'get',
//       url: `${url}/api/Administracion/GetChatToken${params}`,
//       withCredentials: true // <= para que se setee/envíe la cookie
//     }).then(response => resolve(response.data))
//       .catch(reject);
//   });
// };

export const getChatInternoGrupo = (id) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/ChatInterno/Grupo/${id}`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
}

export const updateEstadoGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/CambiarEstadoGrupoPlan`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const putActivarUsuario = (id) => {
    return new Promise((resolve, reject) => {
        const token = localStorage.getItem("token");
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/${id}/Activar`,
            data: {},
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            console.error("DEBUG: putActivarUsuario error", err.response);
            reject(err);
        })
    })
}

export const putPausarUsuario = (id) => {
    return new Promise((resolve, reject) => {
        const token = localStorage.getItem("token");
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/${id}/Pausar`,
            data: {},
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            console.error("DEBUG: putPausarUsuario error", err.response);
            reject(err);

        })
    })
}


export const getTiposUsuarios = (id = null) => { // SE USA EN EL ACTIONS Y TAMBIÉN DIRECTAMENTE
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: id
              ? `${url}/api/TipoUsuario?id=${id}`
              : `${url}/api/TipoUsuario`,
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const postTiposUsuarios = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/CrearTipoUsuario`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const deleteTiposUsuarios = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Usuarios/EliminarTipoUsuario?Id=${id}`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const updateTiposUsuarios = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Usuarios/ModificarTipoUsuario`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)

        })
    })
}

export const postCargaMasivaComprobantesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/Comprobantes`,
            data: request
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const putModificarMasivaComprobantes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Ordenes/ModificarMasivaComprobantes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putReemplazarComprobanteOrdenApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Ordenes/Comprobantes`,
            data: data
        }).then((response) => {
            resolve(response);
        }).catch((err) => {
            reject(err);
        })
    })
}

export const getAccionesPredefinidasTipoUsuarioApi = (idTipoUsuario) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/ObtenerAccionesPredefinidasTipoUsuario`,
            params: { idTipoUsuario: idTipoUsuario }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postAccionPredefinidaTipoUsuarioApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/CrearAccionPredefinidaTipoUsuario`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getTopSellers = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopSellers`,
            params: params ?? null,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const deleteAccionPredefinidaTipoUsuarioApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Usuarios/EliminarAccionPredefinidaTipoUsuario`,
            params: { id: id }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getAccionesApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/ObtenerAcciones`,
            params: params
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const autorizarZipnova = (idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Integraciones/Proveedor/Autorizar`,
            params: {
                userId: idSeller,
                Proveedor: 1
            }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const estadoZipnova = (idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Integraciones/Proveedor/Estado`,
            params: {
                IdUsuario: idSeller,
                Proveedor: 1
            }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const desconectarZipnova = (idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Integraciones/Proveedor/Desconectar`,
            params: {
                userId: idSeller
            }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
};

export const getSellerDesplegableApi = (normalizedParams, token) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/DesplegableSeller`,
            params: normalizedParams,
            headers: token ? { Authorization: token } : undefined
        }).then(response => {
            resolve(response?.data ?? {});
        }).catch(err => {
            reject(err);
        })
    })
}


export const fetchAtributosCategoriaApi = (idSubFamilia) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/AtributosCategoria`,
            params: {
                idSubFamilia: idSubFamilia
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchAtributosPorCategoriaAgrupamientoApi = (idSubFamilia, idAgrupacion, descripcion, noIncluir) => {
    return new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        params.set('idSubFamilia', idSubFamilia ?? '');
        if (idAgrupacion != null) {
            params.set('idAgrupacion', idAgrupacion);
        }
        if (descripcion) {
            params.set('descripcion', descripcion);
        }
        (noIncluir || []).forEach((idAtributo) => params.append('noIncluir', idAtributo));

        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/AtributosCategoria?${params.toString()}`
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchValoresAtributoApi = (idAtributo, descripcion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/ValoresAtributo`,
            params: {
                idAtributo: idAtributo,
                descripcion: descripcion
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchEstructuraAtributosValoresApi = (codProducto, idCategoria) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/EstructuraAtributosValores`,
            params: {
                codProducto: codProducto,
                idCategoria: idCategoria
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchAgrupamientosApi = (idCategoria) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Agrupamientos`,
            params: {
                idCategoria: idCategoria
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const CargarAtributosApi = (valores) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/CargarAtributos`,
            data: valores
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const CargarBlisterApi = (id, datos) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/${id}/Blister`,
            data: datos
        })
        .then(response =>
            resolve(response.data))
        .catch(error =>
            reject(error));
    });
}

export const ObtenerBlisterApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/${id}/Blister`
        })
        .then(response =>
            resolve(response.data))
        .catch(error =>
            reject(error));
    });
}

export const EliminarBlisterApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Publicaciones/${id}/Blister`
        })
        .then(response =>
            resolve(response.data))
        .catch(error =>
            reject(error));
    });
}

export const getSidebarBannersApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/SidebarBanners`
        })
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

export const createSidebarBannerApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/SidebarBanners`,
            data
        })
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

export const updateSidebarBannerApi = (id, data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/SidebarBanners/${id}`,
            data: { ...data, id }
        })
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

export const deleteSidebarBannerApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/SidebarBanners/${id}`
        })
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

export const reorderSidebarBannersApi = (ids) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/SidebarBanners/orden`,
            data: { idsOrdenados: ids }
        })
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

export const uploadSidebarBannerImageApi = (img) => {
    if (!img?.type?.includes('image')) {
        return Promise.reject(new Error('Archivo incorrecto'));
    }

    const form = new FormData();
    form.append('file', img, img.name);

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/SidebarBanners/imagen`,
            data: form
        })
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

export const fetchCuponesPendientesAdminApi = (params) => {
    return axios.get(`${url}/api/Cupones/ObtenerCuponesPendientesAdmin`, {
        params: params ?? null
    }).then(response => response.data);
};

export const fetchCuponesSellerApi = (params) => {
    return axios.get(`${url}/api/Cupones/ObtenerCuponesSeller`, {
        params: params ?? null
    }).then(response => response.data);
};

export const postActualizarEstadoAprobacionAdminApi = (data) => {
    return axios.post(`${url}/api/Cupones/ActualizarEstadoAprobacionAdmin`, data)
        .then(response => response.data);
};

export const postActualizarEstadoAprobacionSellerApi = (data) => {
    return axios.post(`${url}/api/Cupones/ActualizarEstadoAprobacionSeller`, data)
        .then(response => response.data);
};

export const postRevocarAprobacionSellerApi = (data) => {
    return axios.post(`${url}/api/Cupones/RevocarAprobacionSeller`, data)
        .then(response => response.data);
};

